import { useRootLoaderData } from "@made-people/gears-remix";
import { getStoriesFromGlobalStoryblokStoriesByComponentType } from "../../../utils/global-story-functions";
import { SizeGuideData } from "./types";

export const useSizeGuide = (): SizeGuideData | null => {
  const rootLoaderData = useRootLoaderData();

  const globalStoryblokStories =
    rootLoaderData?.settingsAndContentResponse.globalStoryblokStories;
  if (!globalStoryblokStories) {
    return null;
  }

  const sizeGuides = getStoriesFromGlobalStoryblokStoriesByComponentType(
    "SizeGuide",
    globalStoryblokStories,
  );

  if (!sizeGuides || sizeGuides.length === 0) {
    return null;
  }

  if (sizeGuides.length > 1) {
    console.warn(
      "More than one size guide found. Returning the first one. Check that the countries setup in Storyblok is unique per size guide entry.",
    );
  }
  return sizeGuides?.[0] as SizeGuideData;
};
